import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { tap, map } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    tap(isAuth => {
      if (!isAuth) {
        authService.redirectUrl = state.url;
        router.navigate(['/auth/login']);
      }
    }),
    map(isAuth => isAuth)
  );
};
